import script from "./NavbarButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarButtons.vue?vue&type=script&setup=true&lang=js"

import "./NavbarButtons.vue?vue&type=style&index=0&id=391a88b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-391a88b8"]])

export default __exports__